import { useContext } from 'react'
import { ModalContext } from '@/root/shared-providers'

export const useModal = () => {
  return useContext(ModalContext)
}
